import { useRef, useState } from "react";

interface Props {
  accept?: string;
  capture?: boolean | "user" | "environment";
  onPick: (file: File) => void;
  hint?: string;
  /** Affiche un aperçu image si le fichier sélectionné en est une */
  withPreview?: boolean;
}

export default function FileDrop({ accept, capture, onPick, hint, withPreview }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const [picked, setPicked] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  function handle(file: File | null) {
    if (!file) return;
    setPicked(file);
    onPick(file);
    if (withPreview && file.type.startsWith("image/")) {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
    }
  }

  return (
    <div>
      <div
        onClick={() => inputRef.current?.click()}
        onDragEnter={(e) => { e.preventDefault(); setOver(true); }}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          const f = e.dataTransfer.files?.[0];
          if (f) handle(f);
        }}
        style={{
          border: `2px dashed ${over ? "var(--terracotta)" : "var(--line)"}`,
          background: over ? "var(--terra-soft)" : "var(--bg-card)",
          borderRadius: "var(--r-md)",
          padding: 18,
          textAlign: "center",
          cursor: "pointer",
          transition: "all .15s",
        }}
      >
        {picked ? (
          <>
            <div style={{ fontWeight: 600, color: "var(--navy)" }}>📎 {picked.name}</div>
            <div className="tiny">{(picked.size / 1024).toFixed(0)} ko · {picked.type || "fichier"}</div>
            <div className="tiny" style={{ marginTop: 6, color: "var(--blue)" }}>Cliquer pour changer</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: "1.5rem", color: "var(--blue)" }}>+</div>
            <div className="muted">{hint || "Glisse-dépose un fichier ici, ou clique pour en choisir"}</div>
          </>
        )}
      </div>
      {previewUrl && (
        <img src={previewUrl} alt="aperçu" style={{
          width: "100%", maxHeight: 280, objectFit: "contain",
          background: "#000", marginTop: 10, borderRadius: "var(--r-md)",
        }} />
      )}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        capture={capture}
        onChange={(e) => handle(e.target.files?.[0] || null)}
        style={{ display: "none" }}
      />
    </div>
  );
}
